import React from 'react';
import { Checkbox as BaseCheckbox, CheckboxProps as BaseCheckboxProps } from 'antd';

export type CheckboxProps = BaseCheckboxProps & {};

const Checkbox: React.FC<CheckboxProps> = ({ ...props }) => <BaseCheckbox {...props} />;

export default Checkbox;

